import React from 'react';
import { z } from 'zod';

import { StoreConnector, UiKit } from 'components';
import { useForm } from 'utils/hooks';
import { useConnectForm } from '../hooks';
import { STORE_URL_PREFIX, STORE_URL_SUFFIX } from '../stubs';

export const FORM_SCHEMA = z.object({
  storeName: z.string().min(1, 'Store name is required')
});

export default function BigcommerceConnect() {
  const { isConnecting, connect } = useConnectForm();

  const { data, errors, isDirty, onChange, onValidate } = useForm({
    dataSchema: FORM_SCHEMA,
    defaultData: { storeName: '' }
  });

  const onSubmit = e => {
    e.preventDefault();

    const isValid = onValidate(data);
    if (!isValid) return;

    connect({
      shop: `${STORE_URL_PREFIX.BIGCOMMERCE}${data.storeName}${STORE_URL_SUFFIX.BIGCOMMERCE}`
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <StoreConnector.UrlInput
        name="storeName"
        value={data.storeName}
        onChange={value => onChange({ storeName: value })}
        label="Bigcommerce Store Name"
        prefix={STORE_URL_PREFIX.BIGCOMMERCE}
        suffix={STORE_URL_SUFFIX.BIGCOMMERCE}
        error={errors.storeName}
      />
      <UiKit.Button
        disabled={!isDirty}
        processing={isConnecting}
        className="w-100"
      >
        Connect your BigCommerce Store
      </UiKit.Button>
    </form>
  );
}
